import React from 'react';
import DeactivateHealthcareServiceButton from '../component/DeactivateHealthcareServiceButton'
import ActivateHealthcareServiceButton from '../component/ActivateHealthcareServiceButton'

const HealthcareServiceActionButton = (prop) => {
    return (
        prop.record.status === 'ACTIVE' ?
            <DeactivateHealthcareServiceButton {...prop} /> :
            <ActivateHealthcareServiceButton  {...prop} />
    );
};

export default HealthcareServiceActionButton;
